module.exports = __webpack_public_path__ + "static/media/Prema.ded0ab0f.jpg";